import KeycloakService from 'services/KeycloakService'

const RenderOnAdmin = ({ children }: { children: JSX.Element }) => {
  return KeycloakService.isAdmin() ? children : null
}

export default RenderOnAdmin
